/**
 * AbstractCommand
 * Extends AbstractContextObject
 * 
 * Created on 11-apr-2017, 12:22:47
 * @author Reinier Feijen for &ranj
 **/

import AbstractContextObject from "./AbstractContextObject";

export default class AbstractCommand extends AbstractContextObject {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     */
    constructor(dispatcher) {
        super(dispatcher);
    }
}